import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';

export interface SliderCardWrapperProps {
  slidesPerPage?: 1 | 2 | 3;
  showNext?: boolean;
  withStandardHeight?: boolean;
  className?: string;
}

export const SliderCardWrapper = ({
  slidesPerPage = 3,
  showNext = true,
  children,
  withStandardHeight = true,
  className,
}: PropsWithChildren<SliderCardWrapperProps>) => {
  return (
    <div
      className={clsx(
        'snap-start inline-flex overflow-y-visible bg-none',
        showNext ? 'min-w-[90%]' : 'min-w-[100%]',
        className,
        {
          'md:min-w-[calc(33.3%-13px)] md:max-w-[calc(33.3%-13px)]':
            slidesPerPage > 2,
          'sm:min-w-[calc(50%-10px)] sm:max-w-[calc(50%-10px)]':
            slidesPerPage > 1,
          ' h-[400px] max-h-[400px] md:h-[485px] md:max-h-[485px]':
            withStandardHeight,
        }
      )}
    >
      {children}
    </div>
  );
};

export default SliderCardWrapper;
